import { DropdownMenu } from "@swivu/shared-ui";
import {
  CloudIcon,
  GlobeAltIcon,
  MapIcon,
  MapPinIcon
} from "@heroicons/react/24/outline";
import { type TaskDetailResponse } from "@swivu/client-api";

const mapProviders = [
  {
    show: false,
    title: "EagleView ConnectExplorer",
    icon: MapIcon,
    url: "https://explorer.eagleview.com/index.php?lat={lat}&lon={lon}&angle=Or&zoom=19&orientation=N"
  },
  {
    show: true,
    title: "Google Maps",
    icon: MapIcon,
    url: "https://www.google.com/maps?q={lat},{lon}"
  },
  {
    show: false,
    title: "Google Earth",
    icon: GlobeAltIcon,
    url: "https://earth.google.com/web/@{lat},{lon},3000a,0d,0y,0h,0t,0r"
  },
  {
    show: true,
    title: "Google Street View",
    icon: MapPinIcon,
    url: "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={lat},{lon}"
  },
  {
    show: false,
    title: "OpenStreetMap Viewer",
    icon: MapIcon,
    url: "https://www.openstreetmap.org/?mlat={lat}&mlon={lon}#map=18/{lat}/{lon}"
  },
  {
    show: true,
    title: "National Weather Services",
    icon: CloudIcon,
    url: "https://forecast.weather.gov/MapClick.php?lat={lat}&lon={lon}"
  },
  {
    show: false,
    title: "USGS Topographical Map",
    icon: MapIcon,
    url: "https://ngmdb.usgs.gov/topoview/viewer/#14/{lat}/{lon}"
  }
];

const AddressDropdown = ({
  address
}: {
  address: TaskDetailResponse["address"] | null;
}) => {
  if (!address?.formatted_address) return null;
  const replaceLatLon = (url: string) => {
    if (!address?.formatted_address || !address.lat || !address.lon) return url;
    return url
      .replace("{lat}", address.lat.toString())
      .replace("{lon}", address.lon.toString());
  };

  if (!address.lat || !address.lon)
    return (
      <div className="mobile-pref-inline-button mt-1 flex items-center gap-2">
        <MapPinIcon className="mobile-pref-control-icon h-4 w-4" />
        <span className="mobile-pref-card-body text-left text-sm text-mono-600 dark:text-mono-300">
          {address.formatted_address}
        </span>
      </div>
    );
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="mobile-pref-inline-button mt-1 flex cursor-pointer items-center gap-2 transition-opacity hover:opacity-80">
          <MapPinIcon className="mobile-pref-control-icon h-4 w-4" />
          <span className="mobile-pref-card-body text-left text-sm text-mono-600 dark:text-mono-300 underline">
            {address.formatted_address}
          </span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="w-48 bg-white shadow-xl dark:bg-mono-800">
        <DropdownMenu.Label>View with</DropdownMenu.Label>
        <DropdownMenu.Separator className="dark:bg-mono-500/50" />
        {mapProviders
          .filter((provider) => provider.show)
          .map((provider) => (
            <DropdownMenu.Item
              asChild
              key={provider.title}
              className="mobile-pref-menu-item"
            >
              <a
                href={replaceLatLon(provider.url)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2"
              >
                <provider.icon className="mobile-pref-control-icon mt-0.5 h-4 w-4" />
                {provider.title}
              </a>
            </DropdownMenu.Item>
          ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default AddressDropdown;
